import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { sendWsAnswer } from '../../actions/wsAnswer';
import { trackActionButtonClick } from './tracking';
import { currentOpenChatSelector } from '../../selectors';
import { TActionButtonV2 } from '../../types/actionButton';
import { EActionButtonType, TActionButtonV3 } from '../../types/actionButtonV3';
import { doesButtonHaveDailyrentReviewLink } from '../../utils/dailyrent/shouldShowDailyrentReviewButtons';
import { useDailyrentReviewModal } from '../../utils/dailyrent/useDailyrentReviewModal';

type TActionButton = TActionButtonV2 | TActionButtonV3;

export const useActionButtonHandler = (
  actionButton: TActionButton,
  messageId: string,
  communicationId: string | undefined,
): ((evt?: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => void) => {
  const { type, socketPayload, link } = actionButton;

  const dispatch = useDispatch();

  const isDailyrentSuccessReviewButton = doesButtonHaveDailyrentReviewLink(actionButton);

  const currentChat = useSelector(currentOpenChatSelector);
  const { offer, chatId } = currentChat || {};

  const buttonStyle = 'style' in actionButton ? actionButton.style : undefined;
  const buttonName = 'promoName' in actionButton ? actionButton.promoName : actionButton.analyticsName;

  const { openModal } = useDailyrentReviewModal();

  const handleClick = () => {
    if (type === EActionButtonType.Socket) {
      dispatch(sendWsAnswer({ messageId, payload: socketPayload as string }));
    } else if (isDailyrentSuccessReviewButton) {
      openModal();
    }

    trackActionButtonClick(messageId, chatId, buttonName, communicationId, offer, link, buttonStyle);
  };

  return handleClick;
};
